/*
 * Scenario: delete-cursor
 *
 * Schlaegt vor, den Paragraph am Cursor zu loeschen. Der Render-Pfad wird
 * den Text mit Strikethrough zeigen; T togglet das Strikethrough aus
 * (zeigt den Text wieder normal — d.h. die Original-Variante).
 */

import { emit, wait, resolve } from './_helpers.js'

export const name = 'delete-cursor'
export const description = 'Delete the paragraph under the cursor.'

export async function run(state) {
    const toolCallId = 'tu_del_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-delete' }, 0)
    await emit(state, 'thinking', { text: 'This paragraph feels redundant. Should we cut it?' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const paragraphId = resolve(state, '$cursor.paragraphId')
    const baseVersion = resolve(state, '$cursor.version')

    await emit(state, 'proposeDelete', {
        toolCallId,
        paragraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        reason: 'Repeats the previous beat without adding new tension.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Cut. The pacing should feel tighter now.'
            : 'Okay, kept it. Sometimes redundancy is the point.'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
